<div class="contentMain">
  <!-- breadcrumb -->
  <div class="row">
    <div class="col-md-12 card-header mainheader header-container">
      <h5>Branch Creation</h5>
    </div>
    <!-- <div class="col-md-6 ">
            <ol class="breadcrum d-flex justify-content-end">
                <li class="breadcrumb-item"><a href="#">Home</a></li>
                <li class="breadcrumb-item"><a href="#">Dashboard</a></li>
                <li class="breadcrumb-item active" aria-current="page">Branch Creation</li>
            </ol>
        </div> -->
  </div>
  <!--/ breadcrumb-->
  <!-- main body -->
  <main class="row">
    <!-- card -->
    <div class="card">
      <div class="card-body">
        <!-- bootstrap tabs -->
        <div class="kliqtab">
          <!-- Nav tabs -->
          <ul class="nav nav-tabs p-0 mb-3">
            <li class="nav-item">
              <a class="nav-link active" data-toggle="tab" href="#General"
                >General</a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link" data-toggle="tab" href="#StockPoint"
                >Stock Point</a
              >
            </li>
          </ul>
          <!-- Tab panes -->
          <div class="tab-content">
            <div role="tabpanel" class="tab-pane in active p-3" id="General">
              <!-- general -->
              <!--/ row -->
              <div class="row">
                <div class="col-lg-9 col-md-9 col-sm-6">
                  <div class="form-group">
                    <label>Branch Name</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Branch Name"
                    />
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 checkbox pt-4">
                  <div class="form-group">
                    <input id="active1" type="checkbox" />
                    <label for="active1"> Status </label>
                  </div>
                </div>
              </div>
              <!-- /col -->
              <!-- col -->
              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12">
                  <div class="form-group">
                    <label>Branch Code</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Branch Code"
                    />
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 checkbox pt-md-4">
                  <div class="form-group">
                    <input id="active1" type="checkbox" />
                    <label for="active1"> Set Default Branch </label>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 checkbox pt-md-4">
                  <div class="form-group">
                    <input id="active2" type="checkbox" />
                    <label for="active2"> Set Main Branch</label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <h5 class="py-3">Address</h5>
                </div>
                <!-- col -->
                <div class="col-lg-6 col-md-6">
                  <div class="form-group">
                    <label>Address Line 1</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Address Line 1"
                    />
                  </div>
                </div>
                <!-- /col -->
                <!-- col -->
                <div class="col-lg-6 col-md-6">
                  <div class="form-group">
                    <label>Address Line 2</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Address Line 2"
                    />
                  </div>
                </div>
                <!-- /col -->
                <!-- col -->
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <div class="form-group">
                    <label>Area</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Area Name"
                    />
                  </div>
                </div>
                <!-- /col -->
                <!-- col -->
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <div class="form-group">
                    <label>District</label>
                    <div
                      class="
                        select2-container
                        form-control
                        show-tick
                        ms
                        select2
                      "
                      id="s2id_autogen33"
                    >
                      <a
                        href="javascript:void(0)"
                        class="select2-choice"
                        tabindex="-1"
                      >
                        <span class="select2-chosen" id="select2-chosen-34"
                          >Select District</span
                        ><abbr class="select2-search-choice-close"></abbr>
                        <span class="select2-arrow" role="presentation"
                          ><b role="presentation"></b></span></a
                      ><label
                        for="s2id_autogen34"
                        class="select2-offscreen"
                      ></label
                      ><input
                        class="select2-focusser select2-offscreen"
                        type="text"
                        aria-haspopup="true"
                        role="button"
                        aria-labelledby="select2-chosen-34"
                        id="s2id_autogen34"
                      />
                      <div
                        class="
                          select2-drop
                          select2-display-none
                          select2-with-searchbox
                        "
                      >
                        <div class="select2-search">
                          <label
                            for="s2id_autogen34_search"
                            class="select2-offscreen"
                          ></label>
                          <input
                            type="text"
                            autocomplete="off"
                            autocorrect="off"
                            autocapitalize="off"
                            spellcheck="false"
                            class="select2-input"
                            role="combobox"
                            aria-expanded="true"
                            aria-autocomplete="list"
                            aria-owns="select2-results-34"
                            id="s2id_autogen34_search"
                            placeholder=""
                          />
                        </div>
                        <ul
                          class="select2-results"
                          role="listbox"
                          id="select2-results-34"
                        ></ul>
                      </div>
                    </div>
                    <select
                      class="form-control show-tick ms select2"
                      data-placeholder="Select"
                      tabindex="-1"
                      title=""
                      style="display: none"
                    >
                      <option>Select District</option>
                      <option>Select Item1</option>
                      <option>Select Item2</option>
                      <option>Select Item3</option>
                      <option>Select Item4</option>
                    </select>
                  </div>
                </div>
                <!-- /col -->
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <div class="form-group">
                    <label>State</label>
                    <div
                      class="
                        select2-container
                        form-control
                        show-tick
                        ms
                        select2
                      "
                      id="s2id_autogen35"
                    >
                      <a
                        href="javascript:void(0)"
                        class="select2-choice"
                        tabindex="-1"
                      >
                        <span class="select2-chosen" id="select2-chosen-36"
                          >Select State</span
                        ><abbr class="select2-search-choice-close"></abbr>
                        <span class="select2-arrow" role="presentation"
                          ><b role="presentation"></b></span></a
                      ><label
                        for="s2id_autogen36"
                        class="select2-offscreen"
                      ></label
                      ><input
                        class="select2-focusser select2-offscreen"
                        type="text"
                        aria-haspopup="true"
                        role="button"
                        aria-labelledby="select2-chosen-36"
                        id="s2id_autogen36"
                      />
                      <div
                        class="
                          select2-drop
                          select2-display-none
                          select2-with-searchbox
                        "
                      >
                        <div class="select2-search">
                          <label
                            for="s2id_autogen36_search"
                            class="select2-offscreen"
                          ></label>
                          <input
                            type="text"
                            autocomplete="off"
                            autocorrect="off"
                            autocapitalize="off"
                            spellcheck="false"
                            class="select2-input"
                            role="combobox"
                            aria-expanded="true"
                            aria-autocomplete="list"
                            aria-owns="select2-results-36"
                            id="s2id_autogen36_search"
                            placeholder=""
                          />
                        </div>
                        <ul
                          class="select2-results"
                          role="listbox"
                          id="select2-results-36"
                        ></ul>
                      </div>
                    </div>
                    <select
                      class="form-control show-tick ms select2"
                      data-placeholder="Select"
                      tabindex="-1"
                      title=""
                      style="display: none"
                    >
                      <option>Select State</option>
                      <option>Select Item1</option>
                      <option>Select Item2</option>
                      <option>Select Item3</option>
                      <option>Select Item4</option>
                    </select>
                  </div>
                </div>
                <!--/ col -->
                <!-- col -->
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <div class="form-group">
                    <label>Country</label>
                    <div
                      class="
                        select2-container
                        form-control
                        show-tick
                        ms
                        select2
                      "
                      id="s2id_autogen37"
                    >
                      <a
                        href="javascript:void(0)"
                        class="select2-choice"
                        tabindex="-1"
                      >
                        <span class="select2-chosen" id="select2-chosen-38"
                          >Select Country</span
                        ><abbr class="select2-search-choice-close"></abbr>
                        <span class="select2-arrow" role="presentation"
                          ><b role="presentation"></b></span></a
                      ><label
                        for="s2id_autogen38"
                        class="select2-offscreen"
                      ></label
                      ><input
                        class="select2-focusser select2-offscreen"
                        type="text"
                        aria-haspopup="true"
                        role="button"
                        aria-labelledby="select2-chosen-38"
                        id="s2id_autogen38"
                      />
                      <div
                        class="
                          select2-drop
                          select2-display-none
                          select2-with-searchbox
                        "
                      >
                        <div class="select2-search">
                          <label
                            for="s2id_autogen38_search"
                            class="select2-offscreen"
                          ></label>
                          <input
                            type="text"
                            autocomplete="off"
                            autocorrect="off"
                            autocapitalize="off"
                            spellcheck="false"
                            class="select2-input"
                            role="combobox"
                            aria-expanded="true"
                            aria-autocomplete="list"
                            aria-owns="select2-results-38"
                            id="s2id_autogen38_search"
                            placeholder=""
                          />
                        </div>
                        <ul
                          class="select2-results"
                          role="listbox"
                          id="select2-results-38"
                        ></ul>
                      </div>
                    </div>
                    <select
                      class="form-control show-tick ms select2"
                      data-placeholder="Select"
                      tabindex="-1"
                      title=""
                      style="display: none"
                    >
                      <option>Select Country</option>
                      <option>Select Item1</option>
                      <option>Select Item2</option>
                      <option>Select Item3</option>
                      <option>Select Item4</option>
                    </select>
                  </div>
                </div>
                <!-- col -->
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <div class="form-group">
                    <label>Pincode</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder='Pincode"'
                    />
                  </div>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <div class="form-group">
                    <label>Fax No</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Fax No"
                    />
                  </div>
                </div>
                <!-- /col -->
                <!-- col -->
                <!--/ col -->
                <!-- col -->
                <!--/ col -->
                <!-- col -->
                <!-- /col -->
                <!-- col -->
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <div class="form-group">
                    <label>Phone Number 1</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Phone Number"
                    />
                  </div>
                </div>
                <!-- /col -->
                <!-- col -->
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <div class="form-group">
                    <label> Phone Number 2</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Alternative Phone Number"
                    />
                  </div>
                </div>
                <!-- /col -->
                <!-- col -->
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <div class="form-group">
                    <label>Mobile </label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Mobile Number"
                    />
                  </div>
                </div>
                <!-- /col -->
                <!-- col -->
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <div class="form-group">
                    <label>PAN Number</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="PAN Number"
                    />
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6">
                  <div class="form-group">
                    <label>Email ID</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Email ID"
                    />
                  </div>
                </div>
                <!-- /col -->
                <!-- col -->
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <div class="form-group">
                    <label>TIN No</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="TIN No"
                    />
                  </div>
                </div>
                <!-- /col -->
                <!-- col -->
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <div class="form-group">
                    <label>MFL No</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="MFL No"
                    />
                  </div>
                </div>
                <!-- /col -->
                <!-- col -->
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <div class="form-group">
                    <label>TAN No</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="TAN No"
                    />
                  </div>
                </div>
                <!-- /col -->
                <!-- col -->
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <div class="form-group">
                    <label>CST No</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="CST No"
                    />
                  </div>
                </div>
                <!-- /col -->
                <!-- col -->
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <div class="form-group">
                    <label>DL20B</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="DL20B"
                    />
                  </div>
                </div>
                <!-- /col -->
                <!-- col -->
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <div class="form-group">
                    <label>DL21B</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="DL21B"
                    />
                  </div>
                </div>
                <!-- /col -->
                <!-- col -->
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <div class="form-group">
                    <label>Registration No</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Registration No"
                    />
                  </div>
                </div>
                <!-- /col -->
                <!-- col -->
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <div class="form-group">
                    <label>GSTIN Number</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="GSTIN Number"
                    />
                  </div>
                </div>
                <!-- /col -->
                <!-- col -->
                <div class="col-lg-6 col-md-6 col-sm-6">
                  <div class="form-group">
                    <label>Branch Incharge</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Branch Incharge"
                    />
                  </div>
                </div>
                <!-- /col -->
                <!-- col -->
                <!-- /col -->
              </div>
              <!--/ row -->
              <!--/ general -->
            </div>
            <div role="tabpanel" class="tab-pane p-3" id="StockPoint">
              <!-- Stock point -->
              <div>
                <div class="checkbox">
                  <input id="active1" type="checkbox" />
                  <label for="active1"> BO SP </label>
                </div>
                <div class="checkbox">
                  <input id="active2" type="checkbox" />
                  <label for="active2"> HO SP </label>
                </div>
                <div class="checkbox">
                  <input id="active3" type="checkbox" />
                  <label for="active3"> Main Road SP </label>
                </div>
                <div class="checkbox">
                  <input id="active4" type="checkbox" />
                  <label for="active4"> Palaklur SP Road </label>
                </div>
              </div>
              <!--/ Stock Points -->
            </div>
          </div>
        </div>
        <!--/ bootstrap tabs -->
      </div>
      <div class="card-footer text-left w-100">
        <button class="btn redbtn" type="button">F3-Save</button>

        <button class="btn redbtn" type="button">Clear</button>
        <button class="btn redbtn" type="button">Cancel</button>

        <button class="btn redbtn" type="button">Help</button>
      </div>
    </div>
    <!--/ card -->
  </main>
  <!-- main body -->
</div>
